const Pikaday = require('pikaday');
// DATE

var PikaLang = localize({
	en: {
		previousMonth : 'Previous',
		nextMonth     : 'Next',
		months        : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		weekdays      : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		weekdaysShort : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	},
	ru: {
		previousMonth : 'Пред. месяц',
		nextMonth     : 'След. месяц',
		months        : ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
		weekdays      : ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
		weekdaysShort : ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
	}
})

if ($('.js-datepicker').length) {
	var picker = new Pikaday(
	{
		field: $('.js-datepicker')[0],
		i18n: PikaLang,
		firstDay: 1,
		position: 'bottom right',
		minDate: new Date('1920-01-01'),
		maxDate: new Date('2020-12-31'),
		yearRange: [1920,2020],
		onSelect: function(date) {
			var selectedDate = date.getDate()+"."+(date.getMonth()+1)+"."+date.getFullYear();
			this._o.field.value = selectedDate;
		}
	});
}

const initPikadayGroup = function(group){
	var $this = $(group);
	var pickerFrom = new Pikaday({
		field: $this.find('.js-datepickerFrom')[0],
		format: 'DD.MM.YYYY',
		i18n: PikaLang,
		position: 'bottom right',
		firstDay: 1,
		onSelect: function(date) {
			pickerTo.setMinDate(this.getDate());
			var selectedDate = date.getDate()+"."+(date.getMonth()+1)+"."+date.getFullYear();
			this._o.field.value = selectedDate;
		}
	});

	var pickerTo = new Pikaday({
		field: $this.find('.js-datepickerTo')[0],
		format: 'DD.MM.YYYY',
		i18n: PikaLang,
		position: 'bottom right',
		firstDay: 1,
		onSelect: function(date) {
			pickerFrom.setMaxDate(this.getDate());
			var selectedDate = date.getDate()+"."+(date.getMonth()+1)+"."+date.getFullYear();
			this._o.field.value = selectedDate;
		}
	});
}

if ($('.js-pikaday-group').length) {
	initPikadayGroup('.js-pikaday-group');
}

// end Date



// WEBPACK FOOTER //
// ./frontend/components/pickaday/pickaday.js